




import VueOptions from '@utils/VueOptions'
import VenueEditWizard from '@ui/VenueWizard/VenueEditWizard'

settings =
  name: 'VenueEdit'
  components: { VenueEditWizard }

  resources:
    venue:
      resourceName: 'venue'
      slug: 'venues/:venueId/edit'

  vue:
    computed:
      optionsForWizard: ->
        supplierId: @supplierId

      supplierId: -> @prime?.venue?.top_org_id

export default VueOptions.vue settings
